import React, { createContext, useContext, useMemo } from 'react';

// Read access to the auth state App owns (`{ isLoggedIn, cls: Auth, userType,
// email, ... }`) and its setter, so data hooks and deep components no longer
// need `auth` threaded through props.
const AuthContext = createContext(null);

export const AuthProvider = ({ auth, setAuth, children }) => {
    const value = useMemo(() => ({ auth, setAuth }), [auth, setAuth]);
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
    return ctx;
};
